import { Dispatch } from "redux";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import * as Actions from "src/store/actions/testDrive";
import { postTo } from "src/store/dataService/routes/shared/osfetch";
import { patchDealPerson } from "src/store/dataService/actions/deal";
import { findRoute } from "src/store/dataService/routes/util";
import i18n from "src/i18n/i18n";
import { Store } from "src/store";

export const openTestDriveModal = async (
    _next: Dispatch,
    { payload }: ActionType<typeof Actions.openTestDriveModal>
) => {
    if (payload.hasTestDrive) {
        payload.history.push("/my-garage/test-drive/success", { vin: payload.vin });
        return;
    }

    payload.history.push("/my-garage/test-drive", { vin: payload.vin });
};

const closeTestDriveModal = async (
    _next: Dispatch,
    { payload: { history } }: ActionType<typeof Actions.closeTestDriveModal>
) => {
    history.push(
        "/my-garage",
        // @ts-ignore
        "vin" in (history?.location?.state ?? {}) ? { vin: history?.location?.state?.vin } : undefined
    );
};

const rescheduleTestDrive = async (
    _next: Dispatch,
    { payload: { history } }: ActionType<typeof Actions.rescheduleTestDrive>
) => {
    history.push(
        "/my-garage",
        // @ts-ignore
        "vin" in (history?.location?.state ?? {}) ? { vin: history?.location?.state?.vin } : undefined
    );
};

const postTestDriveRequest = async (
    _next: Dispatch,
    {
        payload: { appointment, history, person, setError, setLoading, uuid },
    }: ActionType<typeof Actions.postTestDriveRequest>,
    store: Store
) => {
    const response = await postTo(`/deals/${uuid}/appointment/test_drive`, { ...appointment });

    if (!response.ok) {
        store.dispatch(Actions.postTestDriveFailure(setError, setLoading));
        return;
    }

    store.dispatch(Actions.postTestDriveSuccess(appointment, history, person, uuid));
};

const postTestDriveSuccess = async (
    _next: Dispatch,
    { payload: { appointment, history, person, uuid } }: ActionType<typeof Actions.postTestDriveSuccess>,
    store: Store
) => {
    store.dispatch(patchDealPerson(uuid, person));
    history.push("/my-garage/test-drive/success");
};

const postTestDriveFailure = async (
    _next: Dispatch,
    { payload: { setError, setLoading } }: ActionType<typeof Actions.postTestDriveFailure>
) => {
    setError(i18n.t("TestDriveForm.error.defaultMessage"));
    setLoading(false);
};

export const routes = {
    [Actions.openTestDriveModal.type]: openTestDriveModal,
    [Actions.closeTestDriveModal.type]: closeTestDriveModal,
    [Actions.rescheduleTestDrive.type]: rescheduleTestDrive,
    [Actions.postTestDriveRequest.type]: postTestDriveRequest,
    [Actions.postTestDriveSuccess.type]: postTestDriveSuccess,
    [Actions.postTestDriveFailure.type]: postTestDriveFailure,
};

export default (_next: Dispatch, action: any, store?: Store) => findRoute(routes)(_next, action, store);
